import PropTypes from "prop-types";

export default PropTypes.shape({
  performance: PropTypes.shape({
    memberSince: PropTypes.string,
    avgResponseTime: PropTypes.string,
    hhAvgResponseTime: PropTypes.string,
  }),
});
